/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessDeleteUserBody
 */
export interface BusinessDeleteUserBody {
    /**
     * 
     * @type {string}
     * @memberof BusinessDeleteUserBody
     */
    userId: string;
}

export function BusinessDeleteUserBodyFromJSON(json: any): BusinessDeleteUserBody {
    return BusinessDeleteUserBodyFromJSONTyped(json, false);
}

export function BusinessDeleteUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessDeleteUserBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function BusinessDeleteUserBodyToJSON(value?: BusinessDeleteUserBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}


